var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuspendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12ZM8.5 8.75C8.5 8.33579 8.83579 8 9.25 8C9.66421 8 10 8.33579 10 8.75V15.25C10 15.6642 9.66421 16 9.25 16C8.83579 16 8.5 15.6642 8.5 15.25V8.75ZM14.5 8.75C14.5 8.33579 14.8358 8 15.25 8C15.6642 8 16 8.33579 16 8.75V15.25C16 15.6642 15.6642 16 15.25 16C14.8358 16 14.5 15.6642 14.5 15.25V8.75Z",
    fill: "#828282",
    stroke: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspendIcon);
export default __webpack_public_path__ + "static/media/suspend_icon.1def8a2f38bcce34875b8995fe601d75.svg";
export { ForwardRef as ReactComponent };